import axios from 'axios';
import VueAxios from 'vue-axios';
import Vue from 'vue';
import aes from './aes.js';

let base = '';
// const DEV_BASE = 'http://192.168.110.13:8101/api/travel/v120';
const DEV_BASE = 'http://47.108.183.80:8101/api/travel/v120';
const PROD_BASE = 'https://znyf-api.fcvillage.com/api/travel/v120';
if (process.env.NODE_ENV === 'development') {
    base = DEV_BASE;
}
if (process.env.NODE_ENV === 'production') {
    base = PROD_BASE;
}
// base = PROD_BASE;
const instance = axios.create({
    method: 'post',
    baseURL: base,
    timeout: -1,
    headers: {
        ak: 'F1492F75C570493690E7445914602CC2',
        rs: randomStr(32),
        ts: Date.now(),
        'Content-MD5': '4c56ff4ce4aaf9573aa5dff913df997a',
        'Content-Type': 'application/json;charset=utf-8'
    }
});
instance.interceptors.request.use(function(config) {
    if (base.includes('/api/travel')) {
        config.data = aes.encrypt(config.data);
    }
    return config;
});
instance.interceptors.response.use(function(resp) {
    if (resp.status === 200) {
        const data = resp.data;
        parseImgPro(data);
        return resp.data;
    } else {
        alert(`code: ${resp.status}, txt: ${resp.statusText}`);
        return '';
    }
});

function parseImgPro(obj) {
    for (const pro in obj) {
        /* if (pro === 'titleImg') {
            debugger;
        } */
        if (typeof obj[pro] === 'object') {
            parseImgPro(obj[pro]);
        }
        if (typeof obj[pro] === 'string') {
            obj[pro] = parseObj(obj[pro]);
        }
    }
}

function randomStr(length) {
    const str = 'abcdefghigklmnopqrstuvwxwzABCDEFGHIJKLMNOPQRSTUVWXYZ012345679';
    let randomStr = '';
    for (let i = 0; i < length; i++) {
        let random = Math.random() * 1000;
        random = parseInt(random) % str.length;
        randomStr += str[random];
    }
    return randomStr;
}

function parseObj(str) {
    if (typeof str === 'string') {
        try {
            return JSON.parse(str);
        } catch (e) {
            return str;
        }
    } else {
        return str;
    }
}

Vue.use(VueAxios, instance);
